export default __webpack_public_path__ + "3d7bba16cb1418e57ba19ca7a078e5a0.png";